import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
// import "./add-details.css";
import { connect } from "react-redux";
import MaterialSize from "material-table";
import Spinner from "react-bootstrap/Spinner";
import MaterialTable from "material-table";

import { isEmpty } from "lodash";
import { baseURL, headers } from "../../../global/api";
import { ThemeProvider, createTheme } from "@mui/material";
import { deletePackages, getPackages, updatePackages } from "./Packages.action";
const ViewPackages = (props) => {
  const defaultMaterialTheme = createTheme();
  const permissions = JSON.parse(window.localStorage.getItem("permissions"));
  const Checkpermissions = (permissionsType, permissionsName) => {
    return permissions.some((p) => p[`${permissionsType}`] === permissionsName)
      ? false
      : true;
  };
  useEffect(() => {
    //  props.setHeading("Uom List");
    props.getPackages();
    document.title = props.title;
    // console.log(props.couponsDataList, "list");
  }, []);
  return (
    <>
      {props.isFetchingCouponsData ? (
        <div className="loader-div">
          <Spinner
            variant="primary"
            animation="grow"
            size="xl"
            role="status"
            aria-hidden="true"
          />
        </div>
      ) : (
        <Container fluid>
          <div className="main" style={{ height: "88vh" }}>
            <ThemeProvider theme={defaultMaterialTheme}>
              <MaterialTable
                title="Packages Details"
                columns={[
                  {
                    title: "Package Id",
                    field: "package_id",
                    editable: "never",
                  },
                  { title: "Package Name", field: "name" },
                  { title: "Width", field: "width" },
                  { title: "Height", field: "height" },
                  { title: "Weight", field: "weight" },
                  { title: "Length", field: "length" },
                ]}
                data={props.packagesList}
                //    data={(query) =>
                //     new Promise((resolve, reject) => {
                //         let url = `${baseURL}/country?`;
                //         url += "size=" + query.pageSize;
                //         url += "&page=" + (query.page+1);
                //         //  url += "&search=" + query.search;
                //         fetch(url, {
                //             method: 'GET',
                //             header: headers,
                //         })
                //             .then((response) => response.json())
                //             .then((result) => {
                //                 resolve({
                //                     data: result.data,
                //                     page: result.page,
                //                     totalCount: result.total_results,
                //                 });
                //             });

                //     })
                // }
                options={{
                  actionsColumnIndex: -1,
                  exportButton: true,
                  exportAllData: true,
                  paging: true,
                  pageSize: 50, // make initial page size
                  emptyRowsWhenPaging: false, // To avoid of having empty rows
                  pageSizeOptions: [20, 50, 100, 150, 200], // rows selection options
                  headerStyle: {
                    position: "sticky",
                    top: 0,
                    color: "#00BBBB",
                    fontWeight: "550",
                    onRowAdd: "none",
                  },
                }}
                editable={{
                  isEditHidden: rowData => Checkpermissions("permissions_cat_name", "Packages Edit") ,
                  isDeleteHidden: rowData => Checkpermissions("permissions_cat_name", "Packages Delete") ,
                  onRowUpdate: (newData, oldData) =>
                    new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        {
                          props.updatePackages(newData, oldData);
                        }
                      }, 600);
                    }),
                  onRowDelete: (oldData) =>
                    new Promise((resolve) => {
                      setTimeout(() => {
                        resolve();
                        props.deletePackages(oldData.package_id);
                      }, 600);
                    }),
                }}
              />
            </ThemeProvider>
          </div>
        </Container>
      )}
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getPackages: (data) => dispatch(getPackages(data)),
    deletePackages: (packageId) => dispatch(deletePackages(packageId)),
    updatePackages: (newData, oldData) =>
      dispatch(updatePackages(newData, oldData)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  packagesList: state.CargoPackagesReducer.packagesList,
  isFetchingPackages: state.CargoPackagesReducer.isFetchingPackages,
  // flavorsDataList: state.FlavourReducer.flavorsDataList,
  // sizeDataList: state.sizeReducer.sizeDataList,
  // masterControlDataList:state.MasterControlReducer.masterControlDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewPackages);
